import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'pk-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  @Input() size = 40;
  @Input() top = 50;
  @Input() color = 'white';
  @Input() isVisibleBackface = false;

  constructor() { }

  ngOnInit() {
  }

}
